module.exports = __webpack_public_path__ + "fonts/fa-regular-400.2cd8d991.ttf";